import { useRouter } from 'next/compat/router'
import { useEffect } from 'react'
import { useSearchBox } from 'react-instantsearch'
import { z } from 'zod'

const QuerySchema = z.object({
  q: z.string()
})
export const useVirtualSearchBox = () => {
  const router = useRouter()
  const { refine } = useSearchBox()

  useEffect(() => {
    const parsedQuery = QuerySchema.safeParse(router?.query)
    if (parsedQuery.success) {
      refine(parsedQuery.data.q)
    }
  }, [router?.query.q, refine])

  return null
}
